import _ from 'lodash'
import jimp from 'jimp'
import moment from 'moment'
import { en, es } from 'vuejs-datepicker/dist/locale'

export const localDatepicker = (locale) => {
  switch (locale) {
    case 'es':
      return es
    case 'en':
      return en
    default:
      return es
  }
}

export const isUndefined = value => {
  return value === undefined
}

export const isObject = value => {
  return value === Object(value)
}

export const isArray = value => {
  return Array.isArray(value)
}

export const isFile = value => {
  return value instanceof File
}

export const isFileList = value => {
  return value instanceof FileList
}

export const isDate = value => {
  return value instanceof Date
}

export const isString = value => {
  return typeof value === 'string' || value instanceof String
}

export const isRegExp = value => {
  return value instanceof RegExp
}

export const isBooleand = value => {
  return Boolean(value)
}

export const isNumber = value => {
  return !isNaN(Number(value))
}

export const isElement = value => {
  return (value instanceof Element) || (typeof value === 'object' && value.jquery)
}

export const isFunction = value => {
  return value instanceof Function
}

export const getTypeof = value => {
  return typeof value
}

export const getBoolValue = value => {
  if ((getTypeof(value) === 'string') && (value === 'true' || value === '1')) {
    return true
  } else if ((getTypeof(value) === 'string') && (value === 'false' || value === '0')) {
    return false
  } else if (getTypeof(value) === 'number' && value === 0) {
    return false
  } else if (getTypeof(value) === 'number' && value === 1) {
    return true
  } else if (getTypeof(value) === 'boolean' && value === false) {
    return false
  } else if (getTypeof(value) === 'boolean' && value === true) {
    return true
  } else {
    return false
  }
}

/**
 * @param {Array|Object} value
 * @return {Number}
 */
export const getAmountOfKeys = value => {
  if (!isArray(value) && !isString(value) && !isObject(value)) {
    return 0
  }
  if (isString(value)) {
    return value.length
  }

  return Object.keys(value).length
}

/**
 * @param {Array} value
 * @return {Boolean}
 */
const localVerificationOfVariables = value => {
  let index = 0
  let sw = true
  let currentvalue = null
  while ((value && index < value.length) && (sw === true)) {
    currentvalue = value[index]
    if (typeof currentvalue !== typeof undefined && currentvalue !== false && currentvalue !== null && currentvalue !== '' && currentvalue !== ' ') {
      sw = true
    } else {
      sw = false
    }
    index++
  }

  return sw
}

/**
 * @param {Mixed} value
 * @return {Boolean}
 */
export const checkVariable = (...value) => {
  return localVerificationOfVariables(value)
}

/**
 * @param {Array} value
 * @return {Boolean}
 */
export const checkVariableEcmascript = value => {
  return localVerificationOfVariables(value)
}

/**
 * @param {Array} array
 * @return {String}
 */
const ignoreFirstMatch = array => {
  return array.find(
    value => {
      return !value.match(/=/i)
    },
  )
}

/**
 * Crear los parámetros correctos que serán
 * enviado usando petición GET
 * @param {Object} options
 * @return {String}
 */
export const createTheParametersOfTheUrl = function (options) {
  if (!checkVariable(options)) {
    return ''
  }

  let dataString = ''
  const count = Object.keys(options).length
  let k = 0

  $.each(options, function (i, val) {
    if (k === 0) {
      dataString += '?'
    }
    if (checkVariable(val)) {
      val = isObject(val) ? JSON.stringify(val) : val
      dataString += `${i}=${val || ''}`
      if (k < count - 1) {
        dataString += '&'
      }
    }
    k++
  })

  return dataString
}

/**
 * Crea un objeto con los parametros de una url.
 * Example: ?ejemplo=3
 * @param {String} url
 * @return {Object}
 */
export const getParameterOfTheUrl = function (url) {
  if (!checkVariable(url)) {
    return ''
  }

  const obj = {}
  let extract = url.slice(1).split('&')
  const result = ignoreFirstMatch(extract)
  if (checkVariable(result)) {
    extract = extract = url.slice(1).split('/')
    const temp = {}
    extract.forEach(value => {
      if (!isNaN(parseInt(value))) {
        temp['id'] = value
      } else {
        temp[value] = value
      }
    })
    return getParameterOfTheUrl(createTheParametersOfTheUrl(temp))
  }

  if (extract && extract.length > 0) {
    extract.forEach(value => {
      const split = value.split('=')
      obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1])
    })
  }

  return obj
}

/**
 * @param {File|String} file
 * @param {String} filename
 * @return {File}
 */
export const createFile = (file, filename) => {
  return new File([file], filename, { type: file.type })
}

/**
 * @param {String} dataurl
 * @param {String} filename
 * @return {File}
 */
export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  if (!isArray(arr)) {
    return null
  }

  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

/**
 * @param {HTMLImageElement} img
 * @return {String}
 */
export const getBase64Image = img => {
  if (!checkVariable(img)) {
    return ''
  }

  const canvas = document.createElement('canvas')
  if (!canvas.getContext) {
    return ''
  }

  canvas.width = img.naturalWidth
  canvas.height = img.naturalHeight

  const context = canvas.getContext('2d')
  const ext = getFileName(img.getAttribute('src'), '.')
  context.clearRect(0, 0, canvas.width, canvas.height)
  context.drawImage(img, 0, 0)

  return canvas.toDataURL(`image/${ext}`)
}

/**
 * Versión async de getBase64Image que evita el error "Tainted canvas" al usar
 * fetch para obtener la imagen como Blob (mismo origen), permitiendo exportar
 * el canvas aunque la imagen provenga de un origen distinto (e.g. api.completo365.com).
 *
 * @param {HTMLImageElement|String} imgOrSrc - Elemento img o URL de la imagen
 * @return {Promise<String>}
 */
export const getBase64ImageAsync = async imgOrSrc => {
  if (!checkVariable(imgOrSrc)) {
    return ''
  }

  const src = typeof imgOrSrc === 'string'
    ? imgOrSrc
    : (imgOrSrc.src || imgOrSrc.getAttribute('src') || '')

  if (!src) {
    return ''
  }

  try {
    const response = await fetch(src, { mode: 'cors', cache: 'no-cache' })
    if (!response.ok) {
      return ''
    }
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    return new Promise(resolve => {
      const newImg = new Image()
      newImg.onload = () => {
        const canvas = document.createElement('canvas')
        if (!canvas.getContext) {
          URL.revokeObjectURL(blobUrl)
          resolve('')
          return
        }
        canvas.width = newImg.naturalWidth
        canvas.height = newImg.naturalHeight
        const context = canvas.getContext('2d')
        const ext = getFileName(src, '.') || 'jpeg'
        context.clearRect(0, 0, canvas.width, canvas.height)
        context.drawImage(newImg, 0, 0)
        URL.revokeObjectURL(blobUrl)
        try {
          resolve(canvas.toDataURL(`image/${ext}`))
        } catch (_) {
          resolve('')
        }
      }
      newImg.onerror = () => {
        URL.revokeObjectURL(blobUrl)
        resolve('')
      }
      newImg.src = blobUrl
    })
  } catch (_) {
    return ''
  }
}

/**
 * @param {Array} datos
 * @param {String} value
 */
export const findIndex = (datos, value) => {
  if (isArray(datos)) {
    let sw = true
    let index = 0
    let foundValueValue = null
    while (index < datos.length && sw === true) {
      const current = datos[index]
      if (isObject(current)) {
        const result = getObjectValue(current, value)
        if (checkVariable(result)) {
          sw = false
          foundValueValue = result
        }
      } else if ((isString(current) || isNumber(current)) && (current === value)) {
        sw = false
        foundValueValue = current
      }
      index++
    }
    return foundValueValue
  }

  return null
}

/**
 * @param {Array} datos
 * @param {String|Number} value
 * @return {Mixed}
 */
export const getFirstOccurrence = (datos, value) => {
  if (!isArray(datos)) {
    return null
  }
  if (isArray(datos) && datos.length > 0) {
    let sw = false
    let index = 0
    let foundValueValue = null
    while (index < datos.length && sw === false) {
      if (checkVariable(datos[index]) && !Array.isArray(datos[index]) && datos[index] === value) {
        foundValueValue = datos[index]
        sw = true
      } else if (checkVariable(datos[index]) && Array.isArray(datos[index])) {
        const currentValue = datos[index].find(current => {
          if (isString(current)) {
            return current === value
          }

          return parseInt(current) === value
        })
        if (checkVariable(currentValue)) {
          foundValueValue = currentValue
          sw = true
        }
      }
      index++
    }
    if (sw) {
      return foundValueValue
    }
  }

  return null
}

/**
 * @param {Array} datos
 * @param {Object} valueA
 * @param {Object} valueB
 * @return {Boolean}
 */
const _compareValuesInObject = (datos, valueA, valueB) => {
  let sw = true
  let index = 0
  while (index < datos.length && sw === true) {
    const newValueA = getObjectValue(valueA, datos[index])
    const newValueB = getObjectValue(valueB, datos[index])
    if (!checkVariable(newValueA, newValueB)) {
      sw = false
    }

    if (checkVariable(newValueA, newValueB) && newValueB !== newValueA && sw === true) {
      sw = false
    }

    index++
  }

  return sw
}

/**
 * @param {Array|Object} datos
 * @param {Object|String|Number} value
 * @return {Mixed}
 */
export const getFirstOccurrenceInObject = (datos, value) => {
  let index = 0
  let sw = false
  let type = typeof value
  if (value === null) {
    type = null
  }

  let foundValueValue = undefined
  if (!checkVariable(datos)) {
    return foundValueValue
  }

  const keysData = Object.keys(datos)
  while (index < keysData.length && sw === false) {
    if (checkVariable(keysData[index])) {
      const key = keysData[index]
      switch (type) {
        case 'object':
          const keys = Object.keys(value)
          if (keysData.length === 1 && keys.length === 1) {
            sw = _compareValuesInObject(keysData, datos, value)
          } else if (keysData.length > keys.length) {
            sw = _compareValuesInObject(keysData, datos, value)
          } else if (keysData.length < keys.length) {
            sw = _compareValuesInObject(keys, datos, value)
          } else if (keysData.length === keys.length) {
            sw = _compareValuesInObject(keysData, datos, value)
          }
          if (sw) {
            foundValueValue = value
          }
          break
        default:
          if (value === datos[key]) {
            foundValueValue = datos[key]
            sw = true
          }
          break
      }
    }
    index++
  }

  return foundValueValue
}

/**
 * @param {Array|Object} datos
 * @param {Object|String|Number} value
 * @param {String} key
 * @return {Mixed}
 */
export const getTheFirstOccurrenceByKey = (datos, value, key) => {
  let sw = false
  let foundValueValue = null
  if (Array.isArray(datos) && datos.length > 0) {
    let index = 0
    while (index < datos.length && sw === false) {
      const data = checkVariable(datos[index]) ? datos[index] : null
      if (checkVariable(data, data[key]) && !Array.isArray(data[key]) && data[key] === value) {
        foundValueValue = data
        sw = true
      } else if (checkVariable(data) && Array.isArray(data)) {
        const tempResult = getTheFirstOccurrenceByKey(data, value, key)
        if (checkVariable(tempResult)) {
          foundValueValue = tempResult
          sw = true
        }
      }
      index++
    }
    if (sw) {
      return foundValueValue
    }
  } else if (typeof datos === 'object') {
    foundValueValue = getFirstOccurrenceInObject(datos, value)
    if (checkVariable(foundValueValue)) {
      sw = true
    }
    if (sw) {
      return foundValueValue
    }
  }

  return null
}

/**
 * @param {Array} datos
 * @param {Mixed} value
 * @param {String} key
 * @return {Mixed}
 */
export const getAllAssociatedValues = (datos, value, key) => {
  if (!isArray(datos)) {
    return null
  }
  if (isArray(datos) && datos.length > 0) {
    let index = 0
    const foundValueValue = []
    while (index < datos.length) {
      const data = checkVariable(datos[index]) ? datos[index] : null
      if (checkVariable(data) && Array.isArray(data)) {
        let newIndex = 0
        while (newIndex < data.length) {
          const newData = data[newIndex]
          if (checkVariable(newData, newData[key]) && newData[key] === value) {
            foundValueValue.push(newData)
          }
          newIndex++
        }
      }
      // Other objects
      if (checkVariable(data, data[key]) && data[key] === value) {
        foundValueValue.push(data)
      }
      index++
    }

    return foundValueValue
  }

  return null
}

/**
 * Devuelve el numero en el formato establecido
 * en la función (US$20.40)
 * @param {Number}
 * @return {String}
 */
export const getNumberFormat = (number) => {
  return new Intl.NumberFormat('es-PA', { style: 'currency', currency: 'USD' }).format(number)
}

/**
 * Devuelve el numero en el formato establecido
 * en la función (20.40%)
 * @param {Number}
 * @return {String}
 */
export const getNumberFormatPercent = number => {
  return new Intl.NumberFormat('es-PA', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format((number / 100))
}

/**
 * Devuelve la fecha en el formato (2019-05-28)
 * establecido en la función
 * @param {Date} date
 * @return {String|NaN}
 */
export const toYYYYMMDDString = (date) => {
  return isNaN(date) ? 'NaN' : [date.getFullYear(), date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1), date.getDate() > 9 ? date.getDate() : '0' + date.getDate()].join('-')
}

/**
 * Corta un número flotante a los decimal indicados
 * @param {Number} number
 * @param {Number} precision
 * @return {Number}
 */
export const precision = (number, precision) => {
  return Number.parseFloat(number).toPrecision(precision || 2)
}

/**
 * Convierte un número en formato del
 * método getNumberFormat a flotante
 * @param {String} number
 * @return {Number}
 */
export const formattedValueRetracement = number => {
  if (checkVariable(number) && typeof number === 'string') {
    return getValueNumber(number.replace(/[^0-9\\.]+/g, ''))
  }

  return getValueNumber(number)
}

/**
 * Obtiene el valor despues del indicador.
 * @param {String} root
 * @param {String} delimiter
 * @return {String}
 */
export const getFileName = function (root, delimiter) {
  if (!checkVariable(root)) {
    return ''
  }

  return root.split(delimiter).pop()
}

/**
 * Ordenar un arreglo con la llave dada.
 * @param {Array} array
 * @param {string} key
 */
export const kSort = function (array, key) {
  array.sort((elementA, elementB) => {
    const valueA = typeof elementA[key] !== 'undefined' ? elementA[key] : null
    const valueB = typeof elementB[key] !== 'undefined' ? elementB[key] : null

    if (valueA < valueB) {
      return -1
    }

    if (valueA > valueB) {
      return 1
    }

    return 0
  })

  return array
}

/**
 * Contrae un arreglo de matrices en un unico arreglo plano.
 * @param {Array} array
 * @return {Array}
 */
export const flatten = function (array) {
  const flattend = []
  !(function flat(array) {
    array.forEach(function (el) {
      if (isArray(el)) {
        flat(el)
      } else {
        flattend.push(el)
      }
    })
  })(array)

  return flattend
}

/**
 * @param {Object} object
 * @param {Object} other
 */
export const merge = (object, other) => {
  return _.merge(object, other)
}

/**
 * @param {Object} object
 * @param {Object} sources
 * @param {Function} customizer
 * @return {Object}
 */
export const mergeWith = (object, sources, customizer) => {
  return _.mergeWith(object, sources, customizer)
}

/**
 * @param {Array} array
 * @param  {Array} other
 * @return {Array}
 */
export const concatEcmascript = (array, other) => {
  return _.concat(array, other)
}

/**
 * @param {Array} array
 * @param  {...any} other
 */
export const concat = (array, ...other) => {
  return _.concat(array, other)
}

/**
 * @param {Object} object
 * @param {Array|string} path
 * @param {*} value
 */
export const setObject = (object, path, value) => {
  return _.set(object, path, value)
}

/**
 * @param {Object} object
 * @param {Array|string} path
 * @param {*} value
 */
export const getObject = (object, path, value) => {
  return _.get(object, path, value)
}

/**
 * @param {Object} object
 * @param {Array|string} path
 * @return {Boolean}
 */
export const hasObject = (object) => {
  return _.has(object)
}

/**
 * @param {string} string
 * @param {String} target
 * @param {Number} position
 * @return {Boolean}
 */
export const endsWith = (string, target, position) => {
  return _.endsWith(string, target, position)
}

/**
 * @param {Object|Array} object
 * @return {Array}
 */
export const getKeysObject = object => {
  return _.keys(object)
}

/**
 * @param {Array} objects
 * @param {Function} iteratee
 * @return {Number}
 */
export const maxBy = (objects, iteratee) => {
  return _.maxBy(objects, iteratee)
}

/**
 * @param {Object} object
 * @return {Array}
 */
export const values = object => {
  return _.values(object)
}

/**
 * @param {Object} object
 * @param  {...any} sources
 * @return {Object}
 */
export const assign = (object, ...sources) => {
  return _.assign(object, sources)
}

/**
 *
 * @param {Array} datos
 * @param {Function} predicate
 * @return {Array}
 */
export const remove = (datos, predicate) => {
  return _.remove(datos, predicate)
}
/**
 * @param {Array}
 * @return {Array}
 */
export const clone = datos => {
  return _.clone(datos)
}

/**
 * @param {Array} datos
 * @param {Function} predicate
 * @param {Number} fromIndex
 */
export const findWith = (datos, predicate, fromIndex) => {
  return _.findIndex(datos, predicate, fromIndex)
}

/**
 * @param {Array} datos
 * @param {Number|String} value
 * @param {Number} fromIndex
 */
export const indexOf = (datos, value, fromIndex) => {
  return _.indexOf(datos, value, fromIndex)
}

/**
 * @param {Array|Object} datos
 * @param {Function} predicate
 * @return {Array}
 */
export const filter = (datos, predicate) => {
  return _.filter(datos, predicate)
}

/**
 * @param {Object} datos
 * @param {String|Array} paths
 * @return {Object}
 */
export const pick = (datos, paths) => {
  return _.pick(datos, paths)
}

/**
 * @param {Array|Object} datos
 * @param {Function|String} predicate
 * @return {Array}
 */
export const map = (datos, predicate) => {
  return _.map(datos, predicate)
}

/**
 * @param {Array} datos
 * @param {Array} values
 * @param {Function} comparator
 * @return {Array}
 */
export const differenceWith = (datos, values, comparator) => {
  return _.differenceWith(datos, values, comparator)
}

/**
 * @param {Array} datos
 * @param {Array} values
 * @param {Function} iteratee
 * @return {Array}
 */
export const sortedIndexBy = (datos, values, iteratee) => {
  return _.sortedIndexBy(datos, values, iteratee)
}

/**
 * @param {Array} datos
 * @return {Array}
 */
export const sortedUniq = (datos) => {
  return _.sortedUniq(datos)
}

/**
 * @param {Array|Object} datos
 * @param {Function|Array} iteratees
 * @return {Array}
 */
export const sortBy = (datos, iteratees) => {
  return _.sortBy(datos, iteratees)
}

/**
 * @param {Array|Object} datos
 * @param {Array|Function|Object} iteratees
 * @param {Array} orders
 * @return {Array}
 */
export const orderBy = (datos, iteratees, orders) => {
  return _.orderBy(datos, iteratees, orders)
}

/**
 * @param {Object} datos
 * @param {Array|string} path
 * @return {Boolean}
 */
export const unset = (datos, path) => {
  return _.unset(datos, path)
}

/**
 * @param {Array} datos
 * @param {Function} comparator
 * @return {Array}
 */
export const uniqWith = (datos, comparator) => {
  return _.uniqWith(datos, comparator)
}

/**
 * @param {Number} value
 * @return {Boolean}
 */
export const isDecimal = value => {
  return value % 1 !== 0
}

/**
 * @param {Array} datos
 * @param {Boolean?} unique
 * @return {Array}
 */
export const getKeys = (datos, unique) => {
  if (!checkVariable(datos)) {
    return null
  }
  if (isArray(datos) && datos.length === 0) {
    return null
  }
  const columns = []
  datos.forEach(data => {
    columns.push(getKeysObject(data))
  })

  if (unique === true) {
    return getUnique(columns)
  }

  return columns
}

/**
 * @param {String} date
 * @param {String|Array} format
 * @return {moment}
 */
export const momentCustomFormat = (date, format) => {
  if (!checkVariable(date)) {
    date = 'current'
  }

  if (date === 'current' && typeof format === 'string') {
    const newDate = moment().format(format)

    return moment(newDate, format)
  }

  return moment(date, format)
}

/**
 * Formato: 30-11-2019 Tipo 1:
 * retorna 2019-11-30
 *
 * Formato: 30-11-2019 Tipo 2:
 * retorna 2019-30-11
 *
 * Formato: 30-11-2019 Tipo 3:
 * retorna 30-11-2019
 * @param {String} date
 * @param {Number} type
 * @return {String}
 */
export const dateFormatSettings = (date, type) => {
  if (!checkVariable(date)) {
    return ''
  }
  if (!isString(date)) {
    return date
  }

  const parts = date.split(/[-\\ /]/)
  const horario = parts && parts[4] !== undefined ? parts[4] : ''
  const hour = checkVariable(parts, parts[3]) ? `${parts[3]}:00` : ''

  if (type === 1) {
    return `${parts[2]}-${parts[1]}-${parts[0]} ${hour} ${horario}`.trim()
  }
  if (type === 2) {
    return `${parts[1]}-${parts[2]}-${parts[0]} ${hour} ${horario}`.trim()
  }
  if (type === 3) {
    return `${parts[0]}-${parts[1]}-${parts[2]} ${hour} ${horario}`.trim()
  }

  return date
}

/**
 * Invierte la fecha dada.
 * @param {String} date
 * @return {String}
 */
export const newDateFormat = date => {
  if (!checkVariable(date)) {
    return null
  }
  if (!isString(date)) {
    return date
  }

  const fullDate = dateFormatSettings(date, 1)

  return momentCustomFormat(fullDate, 'YYYY-MM-DD HH:mm:ss')
}

/**
 * Agrega una semana en base a la fecha dada
 * y obtine la fecha inicial de la semana
 * @param {String} currentDate
 * @return {Object}
 */
export const initDate = currentDate => {
  const date = newDateFormat(currentDate).add(1, 'weeks')

  return date.startOf('isoweek')
}

/**
 * Obtine la fecha inicial de la semana
 * @param {String} currentDate
 * @return {Object}
 */
export const startDateWithoutAdding = currentDate => {
  return newDateFormat(currentDate).startOf('isoweek')
}

/**
 * Obtine la fecha con hora inicial en 0
 * @param {String} currentDate
 * @return {Object}
 */
export const startOfHour = currentDate => {
  const date = momentCustomFormat(currentDate, 'YYYY-MM-DD HH:mm:ss')

  return date.hours(0).startOf('minute').startOf('second')
}

/**
 * Obtine la fecha con hora final en 23:59:59.999
 * @param {String} currentDate
 * @return {Object}
 */
export const endOfHour = currentDate => {
  const date = momentCustomFormat(currentDate, 'YYYY-MM-DD HH:mm:ss')

  return date.hours(23).minutes(59).endOf('second')
}

/**
 * Agrega una semana en base a la fecha dada
 * y obtine la fecha final de la semana
 * @param {String} currentDate
 * @return {Object}
 */
export const lastDate = currentDate => {
  const date = newDateFormat(currentDate).add(1, 'weeks')

  return date.endOf('isoweek')
}

/**
 * Obtine la fecha final de la semana
 * @param {String} currentDate
 * @return {Object}
 */
export const endDateWithoutAdding = currentDate => {
  return newDateFormat(currentDate).endOf('isoweek')
}

/**
 * Agrega un día en base a la fecha dada
 * @param {String} currentDate
 * @return {Object}
 */
export const addDay = currentDate => {
  const date = newDateFormat(currentDate)

  return date.add(24, 'hours')
}

/**
 * Agrega un un día en base a la fecha dada
 * @param {String} currentDate
 * @param {Number} duration
 * @return {Object}
 */
export const addDuration = (currentDate, duration) => {
  const date = newDateFormat(currentDate)

  return date.add(duration, 'days')
}

/**
 * @param {moment|String} date
 * @return {Object}
 */
export const getSeparateDate = date => {
  if (!checkVariable(date)) {
    return null
  }
  if (!(date instanceof moment) && !isString(date)) {
    return null
  }

  const currentDate = isString(date) ? momentCustomFormat(dateFormatSettings(date, 1), 'YYYY-MM-DD') : date
  const day = currentDate.get('date')
  const month = currentDate.get('month')
  const year = currentDate.get('year')

  return { day, month, year }
}

/**
 * @param {String} date
 * @param {String} type
 * @return {Number}
 */
export const getDifference = (date, type) => {
  const currentFormat = momentCustomFormat('current', 'YYYY-MM-DD HH:mm:ss')
  const originDate = newDateFormat(date)

  return checkVariable(currentFormat, originDate) ? currentFormat.diff(originDate, type) : 0
}

/**
 * @param {String} date
 * @return {Number}
 */
export const getDifferenceInDays = date => {
  return getDifference(date, 'days')
}

/**
 * @param {String} date
 * @return {Number}
 */
export const getDifferenceInMinutes = date => {
  return getDifference(date, 'minutes')
}

/**
 * obtener las semanas de un mes
 * @param {String} month
 * @return {Array}
 */
export const getWeeks = month => {
  month = momentCustomFormat(month, 'YYYY-MM')

  let quantityDayWeek = 7
  const last = month.daysInMonth()
  const count = Math.round(Math.abs(last / quantityDayWeek))

  const weeks = []
  weeks.push([1, quantityDayWeek])
  for (let i = 0; i < count; i++) {
    weeks.push([(quantityDayWeek + 1), (Math.min(quantityDayWeek += 7, last))])
  }

  return weeks
}

/**
 * Despliega la fecha actual con el delimitador dado.
 * @param {String} sp
 * @return {String}
 */
export const curday = sp => {
  const today = new Date()
  var dd = today.getDate()
  var mm = today.getMonth() + 1 // As January is 0.
  var yyyy = today.getFullYear()

  if (dd < 10) {
    dd = '0' + dd
  }

  if (mm < 10) {
    mm = '0' + mm
  }

  return (dd + sp + mm + sp + yyyy)
}

/**
 * @param {String} date
 * @return {Date}
 */
export const getTheDateGivenInDateFormat = date => {
  const separate = getSeparateDate(date)
  if (!checkVariable(separate)) {
    return new Date()
  }

  return new Date(separate.year, separate.month, separate.day)
}

/**
 * @param {Number} length
 * @return {String}
 */
export const randomString = length => {
  return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1)
}

/**
 * @return {String}
 */
export const getRandomColor = () => {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }

  return color
}

/**
 * @param {Mixed} obj
 * @return {Mixed}
 */
export const noReactive = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * @param {Array} datos
 * @param {String?} match
 * @return {Array}
 */
export const getUniqueKeys = (datos, match) => {
  const coincidences = []
  datos.forEach(current => {
    if (!isObject(current) && !isArray(current)) {
      return
    }

    const keys = getKeysObject(current)
    keys.forEach(key => {
      const result = findWith(coincidences, val => {
        return val === key
      })
      if (result !== -1) {
        return
      }
      if (checkVariable(match) && regExpTest(match, key)) {
        coincidences.push(key)
      } else if (!checkVariable(match)) {
        coincidences.push(key)
      }
    })
  })

  return coincidences
}

/**
 * @param {Array} datos
 * @param {String|Number}
 * @return {Array|Object}
 */
export const getUniqueWithKey = (datos, key) => {
  const hash = {}
  return datos.filter(current => {
    const valueKey = getObjectValue(current, key)
    const exists = !hash[valueKey] || false
    hash[valueKey] = true

    return exists
  })
}

/**
 * @param {Array} datos
 * @param {Boolean?} withUniqueKey
 * @param {String?} match
 * @return {Array}
 */
export const getUniqueWithKeyWithout = (datos, withUniqueKey, match) => {
  if (!isArray(datos)) {
    return null
  }

  let uniqueKeys = isBooleand(withUniqueKey) && withUniqueKey === true ? getUniqueKeys(datos, match) : getKeys(datos)
  if (!isArray(uniqueKeys)) {
    return null
  }
  if (isArray(uniqueKeys) && uniqueKeys.length === 0) {
    return null
  }

  let hash = {}
  !(function getHash(array, keys) {
    keys.forEach(function (uniqueKey) {
      if (isArray(uniqueKey)) {
        getHash(array, uniqueKey)
      } else {
        const result = findWith(array, val => {
          let keys = null
          if (isObject(val)) {
            keys = getKeysObject(val)
          } else if (isArray(val)) {
            keys = getKeys(val)
          } else {
            keys = [val]
          }
          const tKey = findIndex(keys, uniqueKey)

          return checkVariable(tKey)
        })
        if (result !== -1 && checkVariable(array[result])) {
          hash = { ...hash, ...pick(array[result], keys) }
        }
      }
    })
  })(datos, uniqueKeys)

  return hash
}

/**
 * @param {Array} datos
 * @return {Array}
 */
export const getUnique = datos => {
  const hash = {}
  datos = flatten(datos)

  return datos.filter(current => {
    const exists = !hash[current] || false
    hash[current] = true

    return exists
  })
}

/**
 * @param {Array} datos
 * @return {Mixed}
 */
export const getLast = datos => {
  if (Array.isArray(datos) && datos.length > 0) {
    return datos[datos.length - 1]
  }

  return null
}

/**
 * @param {Array} datos
 * @return {Array}
 */
export const getTheFirst = datos => {
  if (Array.isArray(datos) && datos.length > 0) {
    return datos.slice(0, 1)
  }

  return null
}

/**
 * @param {Array|String} datos
 * @param {Number} indexInit
 * @param {Number} indexMax
 * @return {Array|String}
 */
export const getTheFirstInDicesDice = (datos, indexInit, indexMax) => {
  if (!isArray(datos) && !isString(datos)) {
    return null
  }
  if (datos.length > 0) {
    return datos.slice(indexInit, indexMax)
  }

  return null
}

/**
 * @param {Array} datos
 * @return {String|Object}
 */
export const getTheFirstWithout = datos => {
  const first = getTheFirst(datos)

  return isArray(first) && getAmountOfKeys(first) === 1 ? first[0] : first
}

/**
 * @param {Number} value
 * @return {Number}
 */
export const getValueNumber = value => {
  const type = ['boolean']
  if (!isNaN(value) && type.indexOf(typeof value) === -1) {
    return Number(value)
  }

  return value
}

/**
 * @param {Object} datos
 * @param {Array} keys
 * @return {Array}
 */
export const getObjectValues = (datos, keys) => {
  const results = []
  for (const key of keys) {
    if (datos.hasOwnProperty(key)) {
      const tem = {}
      tem[key] = datos[key]
      results.push(tem)
    }
  }

  return results
}

/**
 * @param {Object} datos
 * @param {String|Array} key
 * @return {Mixed}
 */
export const getObjectValue = (datos, key) => {
  if (!checkVariable(datos)) {
    return null
  }
  if (!checkVariable(key)) {
    return null
  }
  if (isArray(key)) {
    return getObjectValues(datos, key)
  }
  const newIndex = key.indexOf('.')
  if (newIndex !== -1) {
    return getObject(datos, key)
  }
  if (datos.hasOwnProperty(key)) {
    return getValueNumber(datos[key])
  }

  return null
}

/**
 * @param {Number} valueA
 * @param {Number} valueB
 * @param {String} type
 * @return {Number}
 */
const _getMoreOrLess = (valueA, valueB, type) => {
  switch (type) {
    case 'may':
      if (valueA < valueB) {
        return valueB
      }
      break
    case 'less':
      if (valueA > valueB) {
        return valueB
      }
      break
  }

  return null
}

const _getMoreOrLessDate = (dateA, dateB, type) => {
  switch (type) {
    case 'may':
      if (dateB.diff(dateA) > 0) {
        return dateB
      }
      break
    case 'less':
      if (dateB.diff(dateA) < 0) {
        return dateB
      }
      break
  }

  return null
}

/**
 * @param {Array} datos
 * @param {string} key
 * @param {String} codition
 * @param {String} type
 * @return {Mixed}
 */
export const getMoreOrLessPerKey = (datos, key, codition, type) => {
  let result = null
  const first = getTheFirst(datos)
  const newFirst = checkVariable(first) && Array.isArray(first) ? first[0] : first
  let may = checkVariable(newFirst) ? getObjectValue(newFirst, key) : null
  if (!checkVariable(may)) {
    return null
  }
  datos.forEach(values => {
    const currentValue = getObjectValue(values, key)
    if (checkVariable(currentValue)) {
      switch (type) {
        case 'number':
          result = _getMoreOrLess(may, currentValue, codition)
          may = checkVariable(result) ? result : may
          break
        case 'date':
          const newMay = newDateFormat(may)
          const curMay = newDateFormat(currentValue)
          result = _getMoreOrLessDate(newMay, curMay, codition)
          if (checkVariable(result)) {
            const original = result.format('DD-MM-YYYY')
            may = dateFormatSettings(original, 3)
          }
          break
      }
    }
  })

  return may
}

/**
 * @param {*} requireContext
 * @return {Object}
 */
export const getRequireContext = requireContext => {
  const contents = requireContext
    .keys()
    .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
    .reduce(
      (components, [name, component]) => {
        components[name] = component

        return components
      },
      {},
    )

  return contents
}

/**
 * @param {Object} datos
 * @return {Array}
 */
export const arrayFrom = datos => {
  return Array.from(Object.keys(datos), k => datos[k])
}

/**
 * @param {Array} datos
 * @param {String|Number} value
 * @param {Boolean} removed
 * @return {Array}
 */
export const removeItemFromArray = (datos, value, removed) => {
  if (!isArray(datos)) {
    return []
  }
  if (!checkVariable(removed)) {
    removed = false
  }
  const i = datos.indexOf(value)
  if (checkVariable(i) && removed) {
    return datos.splice(i, 1)
  }

  datos.splice(i, 1)

  return datos
}

/**
 * @param {Array} datos
 * @param {String|Array} pull
 * @return {Array}
 */
export const pluck = (datos, pull) => {
  if (isArray(datos) && isString(pull)) {
    return datos.map(dato => dato[pull])
  }
  if (isArray(datos) && isArray(pull)) {
    return datos.map(dato => {
      const newArr = {}
      pull.forEach(k => {
        if (checkVariable(dato[k])) {
          newArr[k] = dato[k]
        }
      })

      return newArr
    })
  }

  return []
}

/**
 * @param {Array} datos
 * @param {Array} header
 * @return {Array}
 */
export const arrayCombineWith = (datos, header) => {
  return datos.map(dato => {
    const newDato = arrayFrom(dato)
    const temp = {}
    header.forEach((h, k) => {
      temp[h] = newDato[k]
    })

    return temp
  })
}

/**
 * @param {Array} datos
 * @param {Array} header
 * @return {Array}
 */
export const arrayCombine = (datos, header) => {
  return datos.map((dato, index) => header[index])
}

const convertObjectToArrayWithKey = values => {
  const newValues = []
  Object.keys(values).forEach(key => {
    newValues[key] = values[key]
  })

  return newValues
}

/**
 * @param {Array} datos
 * @param {Object} value
 * @param {String} key
 * @return {Boolean}
 */
export const includes = (datos, value, key) => {
  if (!checkVariable(value)) {
    value = 0
  }
  if (!isArray(datos)) {
    throw TypeError('first argument must be an Array')
  }
  if (isRegExp(value)) {
    throw TypeError('second argument must not be a RegExp')
  }

  if (isObject(value)) {
    let sw = false
    const newValue = convertObjectToArrayWithKey(value)
    for (const currentKey in newValue) {
      const check = getObjectValue(newValue, currentKey)
      if (checkVariable(check) && check[key]) {
        const result = getFirstOccurrence(datos, currentKey)
        if (checkVariable(result)) {
          sw = true
          break
        }
      }
    }

    return sw
  }

  return false
}

/**
 * @param {HTMLElement|File} inputField
 * @param {Number} clientWidth
 * @param {Number} clientHeight
 */
export const asyncTakeCareOfCompressingOnly = async (inputField, clientWidth, clientHeight, useOriginalName) => {
  let testFile = null
  const file = checkVariable(inputField) && checkVariable(inputField.files) && !isUndefined(inputField.files[0]) ? inputField.files[0] : inputField
  if (!isFile(file)) {
    return false
  }
  if (['png', 'jpg', 'jpeg'].indexOf(getFileName(inputField.value, '.')) === -1) {
    return file
  }

  const resultJimp = await jimp.read(URL.createObjectURL(file))
  resultJimp.scaleToFit(clientWidth, clientHeight)
  resultJimp.quality(100)
  let type = null
  switch (file.type) {
    case 'image/jpg':
      type = jimp.MIME_JPEG
      break
    default:
      type = file.type
      break
  }
  const data = await resultJimp.getBase64Async(type).catch((err) => {
    throw err
  })
  let fileName = `${clientWidth}x${clientHeight}`
  if (useOriginalName) {
    fileName = file.name
  }
  testFile = dataURLtoFile(data, fileName)

  return testFile
}

/**
 * @param {FileList} files
 * @return {Promise}
 */
export const asyncGetNaturalSizeImage = async (files) => {
  if (!(files instanceof FileList)) {
    return new Promise(resolve => {
      resolve({ width: 1000, height: 1000 })
    })
  }

  const datos = []
  Object.keys(files).forEach(async key => {
    const file = files[key]
    const data = await new Promise(resolve => {
      if (['image/jpeg', 'image/jpg', 'image/png'].indexOf(file.type) === -1) {
        resolve({ width: 1000, height: 1000 })
      } else {
        const src = URL.createObjectURL(file)
        const reader = new Image()
        reader.src = src
        reader.onload = (function (event) {
          const img = event.target
          resolve({ width: (img.naturalWidth ?? img.width), height: (img.naturalHeight ?? img.height) })
        })
      }
    })
    datos.push(data)
  })

  return datos
}

/**
 * Patrones aceptados / Accepted patterns
 * Regular (provincia-libro-tomo). Ej: 1-1234-12345
 * Panameño nacido en el extranjero (PE-libro-tomo). Ej: PE-1234-12345
 * Extranjero con cédula (E-libro-tomo). Ej: E-1234-12345
 * Naturalizado (N-libro-tomo). Ej: N-1234-12345
 * Panameños nacidos antes de la vigencia (provinciaAV-libro-tomo). Ej: 1AV-1234-12345
 * Población indigena (provinciaPI-libro-tomo). Ej: 1PI-1234-12345
 *
 * Identificación de las provincias

 * 1 Bocas del Toro
 * 2 Coclé
 * 3 Colón
 * 4 Chiriquí
 * 5 Darién
 * 6 Herrera
 * 7 Los Santos
 * 8 Panamá
 * 9 Veraguas
 * 10 Guna Yala
 * 11 Emberá Wounaan
 * 12 Ngäbe-Buglé
 * 13 Panamá Oeste
 *
 * @param {String} cedula
 * @return {Object}
 */
export const verifyPersonalID = cedula => {
  const insert = (matched, index, item) => {
    matched.splice(index, 0, item)
  }
  const re = /^P$|^(?:PE|E|N|[23456789]|[23456789](?:A|P)?|1[0123]?|1[0123]?(?:A|P)?)$|^(?:PE|E|N|[23456789]|[23456789](?:AV|PI)?|1[0123]?|1[0123]?(?:AV|PI)?)-?$|^(?:PE|E|N|[23456789](?:AV|PI)?|1[0123]?(?:AV|PI)?)-(?:\d{1,4})-?$|^(PE|E|N|[23456789](?:AV|PI)?|1[0123]?(?:AV|PI)?)-(\d{1,4})-(\d{1,5})$/i
  const matched = cedula.match(re)
  let isComplete = false
  if (matched !== null) {
    matched.splice(0, 1)
    if (matched[0] !== undefined) {
      isComplete = true
      if (matched[0].match(/^PE|E|N$/)) {
        insert(matched, 0, '0')
      }
      if (matched[0].match(/^(1[0123]?|[23456789])?$/)) {
        insert(matched, 1, '')
      }
      if (matched[0].match(/^(1[0123]?|[23456789])(AV|PI)$/)) {
        const tmp = matched[0].match(/(\d+)(\w+)/)
        matched.splice(0, 1)
        insert(matched, 0, tmp[1])
        insert(matched, 1, tmp[2])
      }
    }
  }

  return {
    'isValid': cedula.length === 0 ? true : re.test(cedula), // booleano que indica si la cadena podría formar parte de una cédula (true)
    'inputString': cedula, // es el parámetro de entrada.
    'isComplete': isComplete, // booleano que indica si la cadena es una cédula completa.
    'cedula': isComplete ? matched.splice(0, 4) : null, // array con los campos de la cédula (provincia, letra, libro, tomo) separados.
  }
}

/**
 * @param {Array} datos
 * @return {Array}
 */
export const getValues = datos => {
  if (checkVariable(datos) && !isArray(datos)) {
    datos = Object.values(datos)
  }
  if (!isArray(datos)) {
    return []
  }
  const all = []
  for (const value of datos) {
    if (isObject(value)) {
      for (const key in value) {
        all.push(value[key])
      }
    } else {
      all.push(value)
    }
  }

  return all
}

/**
 * @param {Array} datos
 * @param {String} match
 * @return {Array}
 */
export const notInMatch = (datos, match) => {
  if (!isArray(datos)) {
    return []
  }

  const coincidences = []
  datos.forEach(current => {
    if (!isObject(current) && !isArray(current)) {
      return
    }

    const tKeys = []
    const keys = getKeysObject(current)
    keys.forEach(key => {
      const bMatch = regExpTest(match, key)
      if (bMatch === false) {
        tKeys.push(key)
      }
    })
    coincidences.push(pick(current, tKeys))
  })

  return coincidences
}

/**
 * @param {Array} datos
 * @param {String|Number} values
 * @param {Array|String} keys
 * @return {Array}
 */
export const whereNotIn = (datos, values, keys) => {
  if (!isArray(datos)) {
    return []
  }
  if (!isString(values) && isNaN(values)) {
    return []
  }

  let valuesArr = []
  if (isString(keys)) {
    valuesArr = pluck(datos, keys)
  }
  if (isArray(keys)) {
    valuesArr = getValues(pluck(datos, keys))
  }

  return valuesArr.filter(current => {
    if (isString(current) || !isNaN(current)) {
      return current !== values
    }
  })
}

/**
 * @param {Array} datos
 * @param {String|Number} values
 * @param {Array|String} keys
 * @return {Array}
 */
export const whereNotInWith = (datos, values, keys) => {
  if (!isArray(datos)) {
    return []
  }
  if (!isString(values) && isNaN(values)) {
    return []
  }

  return datos.filter(current => {
    if (isObject(current)) {
      const value = getObjectValue(current, keys)

      return value !== values
    }
  })
}

/**
 * @param {Array} datos
 * @param {Object|String|Number} values
 * @return {Array}
 */
export const whereInWith = (datos, values) => {
  if (!isArray(datos) || getAmountOfKeys(datos) === 0) {
    return []
  }
  if (!isString(values) && isNaN(values) && !isObject(values)) {
    return []
  }

  return datos.filter(currentDato => {
    if (isObject(values) && isObject(currentDato)) {
      let sw = true
      for (const key in values) {
        const val = values[key]
        if ((isString(val) || isNumber(val)) && (currentDato.hasOwnProperty(key) && currentDato[key] !== val)) {
          sw = false
        }
        if (isObject(val) && currentDato.hasOwnProperty(key) && isArray(currentDato[key])) {
          const currentValue = currentDato[key]
          const obResult = findWith(currentValue, val)
          if (obResult === -1) {
            sw = false
          }
        }
      }

      return sw
    }

    return false
  })
}

/**
 * @param {String} value
 * @param {String} searchString
 * @return {Number}
 */
export const getLastIndexOf = (value, searchString) => {
  if (!isString(value)) {
    return -1
  }

  return value.substring(value.length - 1).lastIndexOf(searchString)
}

/**
 * @param {Number} number
 * @param {String} type
 * @return {Array}
 */
export const createListNumber = (number, type) => {
  let index = 0
  const values = type === 'array' ? [] : type === 'object' ? {} : null
  while (index < number) {
    if (checkVariable(values)) {
      values[index + 1] = index + 1
    }
    index++
  }

  return values
}

/**
 * @param {String} pattern
 * @param {String} test
 * @return {Boolean}
 */
export const regExpTest = (pattern, test) => {
  const reg = new RegExp(pattern, 'i')

  return reg.test(test)
}

/**
 * @param {Boolean} loading
 * @return {Promise}
 */
export const interval = loading => {
  return new Promise(resolve => {
    const timer = setInterval(() => {
      if (loading === false) {
        clearInterval(timer)
        resolve(loading)
      }
    }, 100)
  })
}

/**
 * @param {String} base64String
 * @return {Uint8Array}
 */
export const urlBase64ToUint8Array = base64String => {
  if (isString(base64String) === false) {
    return
  }

  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  const rawData = atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

/**
 * @param {Array} matched
 * @param {Number} index
 * @param {*} item
 */
export const insertArray = (matched, index, item) => {
  return matched.splice(index, 0, item)
}

/**
 * @param {String} value
 * @param {String} searchString
 * @return {String}
 */
export const getSubstr = (value, searchString) => {
  if (!isString(value)) {
    return -1
  }

  const firstOccurrence = value.indexOf(searchString)

  return getTheFirstInDicesDice(value, 0, firstOccurrence)
}

/**
 * @param {String} value
 * @param {RegExp|String} regex
 * @param {String|Function} newSubStr
 * @return {String}
 */
export const replace = (value, regex, newSubStr) => {
  return value.replace(regex, newSubStr)
}

/**
 * @param {String} value
 * @param {RegExp|String} regex
 * @param {String|Function} newSubStr
 * @return {String}
 */
export const replaceAll = (value, regex, newSubStr) => {
  return value.replaceAll(regex, newSubStr)
}

/**
 * @param {Object} datos
 * @param {String} value
 * @param {String} text
 * @return {Array}
 */
export const getArrayValues = (datos, value, text) => {
  const results = []
  for (const data of datos) {
    if (isObject(data) && data.hasOwnProperty(value) && data.hasOwnProperty(text)) {
      const index = getObjectValue(data, value)
      const valueText = getObjectValue(data, text)
      const tem = []
      tem[index] = valueText
      results.push(tem)
    }
  }

  return results
}

/**
 * @return {Boolean}
 */
export const mobileAndTabletcheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))) {
      check = true
    }
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check
}

/**
 * @param {Array} datos
 * @param {String} value
 * @param {String} text
 * @param {String|Array} description
 * @return {Array}
 */
export const setTransform = (datos, value, text, description) => {
  const keyText = getFileName(text, '.')
  const keyValue = getFileName(value, '.')

  return map(datos, currentValue => {
    const newData = {}
    const columns = []
    if (isArray(description)) {
      description.forEach(des => {
        const rDes = getObjectValue(currentValue, des)
        if (checkVariable(rDes)) {
          columns.push(rDes)
        }
      })
    }

    const header = columns.join(',')
    newData[keyValue] = isObject(currentValue) ? getObjectValue(currentValue, value) : currentValue
    newData[keyText] = isObject(currentValue) ? `${getObjectValue(currentValue, text)}(${header})` : currentValue

    return newData
  })
}

/**
 * @param {Array} datos
 * @param {Array} values
 * @param {Boolean} beginning
 * @return {Array}
 */
export const compareArrangementWith = (datos, values, beginning) => {
  if (!isArray(values)) {
    values = []
  }
  if (!isArray(datos)) {
    datos = []
  }
  if (isArray(datos) && getAmountOfKeys(datos) === 0) {
    return values
  }

  values.forEach(current => {
    const result = whereInWith(datos, pick(current, 'id'))
    if (getAmountOfKeys(result) === 0) {
      if (beginning === true) {
        insertArray(datos, 0, current)
      } else {
        datos.push(current)
      }
    }
  })

  return datos
}
